import { useApi } from '#shared/providers/Api';
import useUsers from '../useUsers';
import unwrap from '../unwrap';

export default function useUserPermissions() {
  const api = useApi();
  const { account } = useUsers();

  async function fetchUserPermissions(params: { EmailAddress: string }) {
    return (await unwrap(api.fetchAccountUserPermissionsNew(params, account.bearer))).Permissions;
  }

  function saveUserPermissions({
    EmailAddress,
    values,
  }: {
    EmailAddress: string;
    values: { [permissionKey: string]: boolean };
  }) {
    return unwrap(api.postAccountUserPermissions({ EmailAddress, ...values }, account.bearer));
  }

  return { fetchUserPermissions, saveUserPermissions };
}
